import { Injectable } from '@angular/core'
import { ContentItemService } from '@engineering11/content-web'
import { ICandidateProfileContentItem } from '@candidate/app/models/candidate-profile/candidate-profile.model'

@Injectable({
  providedIn: 'root',
})
export class CandidateProfileService extends ContentItemService<ICandidateProfileContentItem> {}
